import {contains, keys} from 'ramda'

let urlConfig = {
  'dev': 'https://monitor-x.apps-test.creditsafe.com/api/v1/',
  'test': 'https://monitor-x.apps-test.creditsafe.com/api/v1/',
  'stage': 'https://monitor-x.apps-stage.creditsafe.com/api/v1/',
  'live': 'https://monitor-x.apps.creditsafe.com/api/v1/',
}

const getAPIURL = async function (location) {
  const host = location.host
  // our urls are like 'dev-monitoring.creditsafe.com'
  // 'test-monitoring.creditsafe.com'
  // so get the text until the '-' to get the environment.
  const hyphenIndex = host.indexOf('-')
  const env = host.substr(0, hyphenIndex)

  const isEnvAvailableInURL = contains(env, keys(urlConfig))

  return isEnvAvailableInURL ? urlConfig[env.toLowerCase()]
    : host.indexOf('localhost') > -1 ? urlConfig['test'] : urlConfig['live']
}

export default getAPIURL

export const getURLWithoutPortfolioId = (url, portfolioId) => (portfolioId === 0) ? `${url}`
  : `portfolios/${portfolioId}/${url}`



// WEBPACK FOOTER //
// ./src/api-url-util.js